<template>
  <div class="">
    <div>
      <b-overlay
        :show="this.showOverlay"
        no-wrap
        variant="info"
        :opacity="0.5"
        rounded="sm"
        ><template #overlay>
          <b-spinner
            style="width: 3rem; height: 3rem;"
            type="grow"
            label="Uploading..."
            variant="light"
          ></b-spinner>
          <div class="text-center">
            <p id="cancel-label">File is Uploading...</p>
          </div>
        </template>
      </b-overlay>
      <b-card
        border-variant="secondary"
        align="center"
        header-bg-variant="light"
        footer-tag="footer"
      >
        <!-- {{ this.RiskAssessLoc }} -->

        <h4 class="">Risk Assessment File Management</h4>
        <h4 class="">{{ RiskAssessmentID }}</h4>
      </b-card>

      <br />
      <b-card
        border-variant="secondary"
        align="center"
        header-bg-variant="light"
        footer-tag="footer"
      >
        <b-row><b-col>Select File Type:</b-col></b-row>
        <b-row
          ><b-col
            ><b-select
              :options="FileType"
              v-model="SelectedFileType"
            ></b-select></b-col
        ></b-row>
        <hr />
        <div class="Upload" v-if="SelectedFileType != null">
          <label v-if="SelectedFileType == 'SupportingDoc'"
            >Choose File to upload:</label
          >
          <label v-if="SelectedFileType == 'RiskForm'"
            >Choose Form to upload:</label
          >
          <br />
          <label for="file-upload" class="custom-file-upload">
            <b-icon-file-plus-fill></b-icon-file-plus-fill>

            Select File
          </label>
          <input
            id="file-upload"
            type="file"
            @change="handleFileUpload($event)"
            @click="resetValue()"
          />
        </div>
        <br />
        <h5 v-if="this.file.name">File Name: {{ this.file.name }}</h5>
        <p v-if="this.file.type">File Type: {{ this.file.type }}</p>
        <b-button
          variant="outline-info"
          v-on:click="submitFile()"
          class="mr-1"
          v-if="this.file.name"
          >Upload <b-icon-cloud-arrow-up-fill></b-icon-cloud-arrow-up-fill
        ></b-button>
        <b-button
          variant="outline-danger"
          v-on:click="cancelChooseFile()"
          class="mr-1"
          v-if="this.file.name"
          >Cancel</b-button
        >
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { riskUpload } from "@/Services/aws.js";
import { BIconCloudArrowUpFill, BIconFilePlusFill } from "bootstrap-vue";
import { delay } from "q";

export default {
  computed: {},
  components: {
    BIconCloudArrowUpFill,
    BIconFilePlusFill,
  },

  data() {
    return {
      file: "",
      selectedlocation: localStorage.getItem("CurrentLocation"),
      name: localStorage.getItem("fullname"),
      SelectedFileType: null,
      RiskAssessmentID: this.$LinkedRisk,
      RiskAssessLoc: this.$LinkedRiskLocation,
      FileType: [
        { value: null, text: "Select Document Type" },
        { value: "RiskForm", text: "Risk Assessment Form" },
        { value: "SupportingDoc", text: "Schema/Supporting Document" },
      ],
      items: [],
      response: null,
      modal: false,
      item0: "",
      item1: "",
      item2: "",
      item3: "",
      item4: "",
      showOverlay: false,
      duplicatefile: false,
    };
  },

  beforeMount() {},

  mounted() {},

  methods: {
    handleFileUpload() {
      this.file = event.target.files[0];
    },
    submitFile() {
      if (this.file == "") {
        alert("Please select a file to upload");
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      }
      if (this.file.size > 3500000) {
        alert("file selected is too large, maximum file size is 3.5mb");
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      }
      if (this.file.name.indexOf(" ") >= 0) {
        alert("File Name should not contain spaces");
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      } else {
        this.uploadFile(this.file);
      }
    },

    cancelChooseFile() {
      alert("File Upload Cancelled");
      this.file = "";
      document.getElementById("file-upload").value = null;
    },

    async uploadFile() {
      this.showOverlay = true;
      await delay(5000);

      const result = await riskUpload(
        this.file,
        this.selectedlocation + "/Risk Assessments/" + this.RiskAssessmentID
      );

      if (result.status === 200) {
        // this.showOverlay = false;
        // alert("File upload successful");
        this.filePath = result.fullPath;
        this.submitFileToDB(this.file.name, this.filePath);
        this.file = "";
        document.getElementById("file-upload").value = null;
        // await delay(3000);

        // if (this.SelectedFileType == "RiskForm") {
        //   this.$emit("fileEvent", "RiskForm");
        //   this.showOverlay = false;
        // } else if (this.SelectedFileType == "SupportingDoc") {
        //   this.$emit("fileEvent", "SupportingDoc");
        //   this.showOverlay = false;
        // }
      } else {
        alert("Upload Failed");
      }
      return {
        abort: () => {},
      };
    },

    submitFileToDB(FileSave, FileLocation) {
      this.SubmitUserURN = localStorage.getItem("UserURN");
      let DBSubmitUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let DBSubmitHeaders = this.$apikeyPost;

      let DBSubmitRequest = {
        ServiceType: "RiskAssessment",
        RequestType: "CreateAttachment",
        DataDict: [
          {
            AssessmentID: this.RiskAssessmentID,
            AttachmentName: FileSave,
            AttachmentURL: FileLocation,
            AttachmentType: this.SelectedFileType,
            UploaderURN: this.SubmitUserURN,
          },
        ],
      };
      axios
        .post(DBSubmitUrl, DBSubmitRequest, DBSubmitHeaders)
        .then((response) => {
          response;
          this.MakePDFReadOnly(FileSave, FileLocation);
          // if (this.SelectedFileType == "RiskForm") {
          //   this.$emit("fileEvent", "RiskForm");
          //   this.showOverlay = false;
          // } else if (this.SelectedFileType == "SupportingDoc") {
          //   this.$emit("fileEvent", "SupportingDoc");
          //   this.showOverlay = false;
          // }
        });
    },

    MakePDFReadOnly(FileSave) {
      // for (var i = 0; i < this.AssessmentObject.Documents.length; i++) {

      if (FileSave.split(".")[1] == "pdf") {
        let DetailsLookupURL =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/s3";
        let DetailsLookupHeaders = this.$apikeyPost;
        let DetailsLookupRequest = {
          RequestType: "MakePDFReadOnly",
          DataDict: [
            {
              AssessmentID: this.RiskAssessmentID,
              Location: this.RiskAssessLoc,
              FileName: FileSave,
            },
          ],
        };
        axios
          .post(DetailsLookupURL, DetailsLookupRequest, DetailsLookupHeaders)
          .then((response) => {
            response;
            alert("File upload successful");
            if (this.SelectedFileType == "RiskForm") {
              this.$emit("fileEvent", "RiskForm");
              this.showOverlay = false;
            } else if (this.SelectedFileType == "SupportingDoc") {
              this.$emit("fileEvent", "SupportingDoc");
              this.showOverlay = false;
            }
          });
      } else {
        if (this.SelectedFileType == "RiskForm") {
          this.$emit("fileEvent", "RiskForm");
          this.showOverlay = false;
        } else if (this.SelectedFileType == "SupportingDoc") {
          this.$emit("fileEvent", "SupportingDoc");
          this.showOverlay = false;
        }
      }
    },

    resetValue() {
      this.file = "";
      document.getElementById("file-upload").value = null;
    },
  },
};
</script>

<style>
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid cadetblue;
  border-radius: 5px;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  color: cadetblue;
}

#cancel-label {
  color: white;
  font-size: large;
}

.Upload label {
  font-size: 15px;
}

.modal {
  text-align: center;
}
</style>
